export const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['iphone', 'android', 'ipad', 'ipod', 'blackberry', 'windows phone'];
    const isSmallScreen = window.innerWidth <= 768;
    return mobileKeywords.some(keyword => userAgent.includes(keyword)) || isSmallScreen;
};